import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface PermisisonData {
  uuid: string
  addedPermissions: []
  removedPermissions: []
  addedRoles: []
  removedRoles: []
}


export function useOrganisationUserPermissionsUpdate() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userData: object): Promise<PermisisonData> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/update_organisation_user_permissions`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: JSON.stringify(userData),
        }
      );

      return response.json();
    },
  });
}